import { FarmInToken, FarmState } from "./types";

export const USDe: FarmInToken = {
  address: "0x5d3a1Ff2b6BAb83b63cd9AD0787074081a52ef34",
  symbol: "USDe",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};
export const sUSDe: FarmInToken = {
  address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
  symbol: "sUSDe",
  shouldBeSwapped: false,
  needApprove: true,
  decimals: 18,
};

export const BLAST_FARM_STATE: FarmState = {
  "0xc91D6032d72796b9a0558Ab9ef45C100c9fDe1f8": {
    tokens: [USDe],
  },
  "0x12afF531E86f5E9763c6C7D0994AdEfB1a1f844c": {
    tokens: [sUSDe],
  },
};
